import {getAuth, signInWithPopup, GoogleAuthProvider} from 'firebase/auth';
import { useContext, useEffect } from 'react';
import { ProfileContext } from './contexts/profileContext';
import { useNavigate } from 'react-router-dom';

export default function SignIn() {
    const navigate = useNavigate();
    const apiURL = process.env.REACT_APP_ENVIRONMENT === 'development' ? process.env.REACT_APP_DEV_API_URL : process.env.REACT_APP_PROD_API_URL;
    const { userProfile, updateProfile } = useContext(ProfileContext);

    useEffect(() => {
        if (!userProfile) {
            return;
        } else {
            navigate('/');
        }
    }, [userProfile]);


    const signInWithGoogle = () => {
        const auth = getAuth();
        signInWithPopup(auth, new GoogleAuthProvider().setCustomParameters({prompt: 'select_account'}))
            .then(async (result) => {
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential.accessToken;
                const user = result.user;

                // check if user exists, if not send to backend to create user
                fetch(`${apiURL}/api/login`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        googleID: user.uid,
                        name: user.displayName,
                        email: user.email
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {

                    }
                    console.log(data)
                    updateProfile(data.user);
                    localStorage.setItem('token', data.token);
                    navigate('/');
                })
                .catch((error) => {
                    console.error('Error:', error);
                })


            }).catch((error) => {
                // show error
                // const errorCode = error.code;
                // const errorMessage = error.message;
                // const email = error.email;
                // const credential = GoogleAuthProvider.credentialFromError(error);
                console.log(error);
            });
    }

    return (
        <section class="text-gray-600 body-font relative">
        <div class="container px-5 py-32 mx-auto">
            <div class="flex flex-col text-center w-full mb-4 gap-5">
                <h1 class="sm:text-3xl text-2xl font-medium title-font text-gray-900">Sign Up</h1>
                <button onClick={signInWithGoogle} class="m-auto px-4 py-2 border flex gap-2 border-slate-700 rounded-lg text-slate-700 hover:border-slate-400 0 hover:text-slate-900 dark:hover:text-slate-300 hover:shadow transition duration-150">
                    <img class="w-6 h-6" src="https://www.svgrepo.com/show/475656/google-color.svg" loading="lazy" alt="google logo"/>
                    <span>Login with Google</span>
                </button>
                <p>By signing up, you agree to Lingologue's terms of service and privacy policy.</p>
            </div>
            
        </div>
        </section>
    )
}